import axios from 'axios'
import { confirm } from '../../shared/ui/confirmStore'

// Одинаковый ИНН у двух клиентов — предупреждение, а не запрет (решение
// Сергея 14.09.2026). Сервер отвечает 409 с кодом DUPLICATE_INN и готовым
// русским текстом; форма спрашивает подтверждение и повторяет запрос с
// confirmDuplicateInn: true.

const DUPLICATE_INN_CODE = 'DUPLICATE_INN'

/** Текст сервера, если ошибка — «такой ИНН уже есть»; иначе null. */
export function duplicateInnMessage(error: unknown): string | null {
  if (!axios.isAxiosError(error)) return null
  const body = error.response?.data as { error?: { code?: unknown; message?: unknown } } | undefined
  if (body?.error?.code !== DUPLICATE_INN_CODE) return null
  return typeof body.error.message === 'string' ? body.error.message : null
}

/** true — ошибка про дубль ИНН и пользователь решил сохранить всё равно. */
export async function askSaveDespiteDuplicateInn(error: unknown): Promise<boolean> {
  const message = duplicateInnMessage(error)
  if (!message) return false
  return confirm({
    title: 'Такой ИНН уже есть',
    message: `${message}. Сохранить всё равно?`,
    confirmText: 'Сохранить',
  })
}
